module.exports = __webpack_public_path__ + "static/media/mac-os.f888d95e.svg";